import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Dropdown, Form } from "semantic-ui-react";

export const AdvertiserField = ({
  values,
  updateValues,
  advertisers,
  advertisersLoading,
  campaignsLoading,
  trimmingSearch,
  performSearchAdvertisersDebounced,
  setAdvertisers,
  initialAdvertisers,
}) => {
  const intl = useIntl();

  return (
    <Form.Field className="filter-field">
      <label>
        {intl.formatMessage({
          id: "LABEL_ADVERTISER",
          defaultMessage: "Advertiser",
        })}
      </label>
      <Dropdown
        data-id="advertisers"
        placeholder={intl.formatMessage({
          id: "HINT_ADVERTISER",
          defaultMessage: "Select advertiser",
        })}
        noResultsMessage={intl.formatMessage({
          id: "EMPTY_SEARCH_RESULTS",
          defaultMessage: "No results found",
        })}
        search={!campaignsLoading && trimmingSearch}
        selection
        loading={advertisersLoading}
        options={advertisers}
        name="advertiser_id"
        value={values.advertiser_id}
        clearable
        selectOnNavigation={false}
        onChange={(_e, data) => {
          updateValues({
            // biome-ignore lint/style/useNamingConvention: <sever prop>
            advertiser_id: data.value,
            // biome-ignore lint/style/useNamingConvention: <sever prop>
            campaign_ids: [],
          });
        }}
        onSearchChange={(_event, { searchQuery }) => {
          performSearchAdvertisersDebounced(searchQuery);
        }}
        onBlur={() => {
          if (advertisers.length === 0 && initialAdvertisers) {
            setAdvertisers(initialAdvertisers);
          }
        }}
      />
    </Form.Field>
  );
};

AdvertiserField.propTypes = {
  values: PropTypes.object.isRequired,
  updateValues: PropTypes.func.isRequired,
  advertisers: PropTypes.array.isRequired,
  advertisersLoading: PropTypes.bool.isRequired,
  campaignsLoading: PropTypes.bool.isRequired,
  trimmingSearch: PropTypes.func.isRequired,
  performSearchAdvertisersDebounced: PropTypes.func.isRequired,
  setAdvertisers: PropTypes.func.isRequired,
  initialAdvertisers: PropTypes.object,
};

export default AdvertiserField;
